import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, filter, map } from 'rxjs/operators';

import * as fromRoot from '../reducers';
import { CobrandFacadeService } from '../modules/core/services/cobrand-facade.service';

export const cobrandInfoResolver: ResolveFn<any> = (): Observable<any> | any => {
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	const cobrandFacadeService: CobrandFacadeService = inject(CobrandFacadeService);

    cobrandFacadeService.validateCobrandInfoAndDispatch();

	return store.pipe(
		select(fromRoot.getContentCobrand),
		filter(cobrandData => cobrandData?.loaded === true),
		take(1),
		map(res => {
			return res;
		})
	);
}
